import { Component, Input, OnInit } from "@angular/core";
import { ModalController, Platform } from "@ionic/angular";
import { ToastService } from "src/app/services/toast.service";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { appConstants } from "src/environments/constants";

@Component({
    selector: "app-file-view",
    templateUrl: "./file-view.component.html",
    styleUrls: ["./file-view.component.scss"],
    standalone: false,
})
export class FileViewComponent implements OnInit {
    @Input() imgSource: string;
    @Input() extension: string;
    @Input() description: string;
    @Input() canDelete: boolean;

    public safeUrl: SafeResourceUrl;
    public isImage = false;
    public isVideo = false;
    public device: string;

    constructor(
        private modalController: ModalController,
        private sanitizer: DomSanitizer,
        private toastService: ToastService,
        private platform: Platform
    ) {}

    ngOnInit() {
        this.setDeviceType();
        this.checkFileFormat();
    }

    private setDeviceType = () => {
        if (this.platform.is("ios")) {
            this.device = "ios";
            return;
        }

        this.device = "android";
    };

    private checkFileFormat = () => {
        // if extension is for example image/jpeg
        // take only the last part
        if (this.extension.indexOf("/") > -1) {
            this.extension = this.extension.split("/")[1];
        }

        if (appConstants.imageTypes.includes(this.extension)) {
            this.isImage = true;
            return;
        }

        if (appConstants.videoTypes.includes(this.extension)) {
            this.isVideo = true;
            this.sanitizeUrl();
            return;
        }

        // Not supported files
        this.toastService.showToastMessage("TOAST.WALL_FILE_NOT_SUPPORTED");
        this.closeModal();
    };

    private sanitizeUrl = () => {
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.imgSource);
    };

    // Events
    public closeModal = () => {
        this.modalController.dismiss();
    };

    public removeItem = () => {
        this.modalController.dismiss({
            remove: true,
        });
    };
}
